import { createAction } from '@reduxjs/toolkit';
import { alertActions } from '_actions';
import { messageCenterService } from '_services';
import { ActionNames, Errors } from '_constants'

export const dcDueActions = {
    load: () => dispatch => {
        dispatch(dcDueActions.loadRequest());
        messageCenterService.loadDCDue()
            .then(
                messages => {
                    dispatch(dcDueActions.loadSuccess(messages));
                },
                error => {
                    dispatch(dcDueActions.loadFailure(error));
                    dispatch(alertActions.error(Errors.DC_DUE_LOAD_FAILURE));
                }
            );
    },
    loadRequest: createAction(ActionNames.DC_DUE_LOAD_REQUEST),
    loadSuccess: createAction(ActionNames.DC_DUE_LOAD_SUCCESS),
    loadFailure: createAction(ActionNames.DC_DUE_LOAD_FAILURE),

    setSelectedMessage: createAction(ActionNames.DC_DUE_SET_SELECTED_MESSAGE),

    changeSelection: (epno) => (dispatch, getState) => {
        dispatch(dcDueActions.setSelectedMessage({ epno }));

        if (!getState().entities.dcDue[epno].isRead) {
            dispatch(dcDueActions.markReadRequest({ epno }));

            messageCenterService.markReadPNDCDue(epno, null, null, null, true)
                .then(
                    () => { dispatch(dcDueActions.markReadSuccess(epno)) }
                    ,
                    error => {
                        dispatch(dcDueActions.markReadFailure({ epno, error }));
                        dispatch(alertActions.error(Errors.DC_DUE_MARK_READ_FAILURE));
                    }
                );
        }
    },
    markReadRequest: createAction(ActionNames.DC_DUE_MARK_READ_REQUEST),
    markReadSuccess: createAction(ActionNames.DC_DUE_MARK_READ_SUCCESS),
    markReadFailure: createAction(ActionNames.DC_DUE_MARK_READ_FAILURE),

    clearSelection: createAction(ActionNames.DC_DUE_CLEAR_SELECTION),
}
